export default "__VITE_ASSET__CKQ9iC3a__"